export default "__VITE_ASSET__BbQPzdOg__"